import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';

import {AppSettingsService} from './app-settings.service';
import {BaseRestService} from './base-rest.service';
import {SharedModule} from '../shared.module';
import {serializeQueryString} from '../utilities/serialize-query-string';

@Injectable({providedIn: SharedModule})
export class ProductionLineService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'ProductionLineService'; }

  protected get isAnonymous(): boolean { return false; }

  // tslint:disable-next-line:no-any
  getList(): Observable<SendBackResult<ArrayResponse<any>>> { return this.get<ArrayResponse<any>>(`/ProductionLines`); }
  // tslint:disable-next-line:no-any
  getListWithParams(data: any): Observable<SendBackResult<ArrayResponse<any>>> {
    // tslint:disable-next-line:no-any
    return this.get<ArrayResponse<any>>(`/ProductionLines${serializeQueryString(data)}`);
  }
}
